import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { KnowledgeBaseEntry } from "@school-sales-ai/shared";
import { api } from "@/lib/api";

export function useKbQuery(): ReturnType<typeof useQuery<KnowledgeBaseEntry | null>> {
  return useQuery<KnowledgeBaseEntry | null>({
    queryKey: ["knowledge-base"],
    queryFn: () => api.get<KnowledgeBaseEntry | null>("/crm/knowledge-base"),
  });
}

type MutateArgs = { content: string };

export function useKbMutation(): ReturnType<
  typeof useMutation<KnowledgeBaseEntry, Error, MutateArgs>
> {
  const queryClient = useQueryClient();

  return useMutation<KnowledgeBaseEntry, Error, MutateArgs>({
    mutationFn: ({ content }) =>
      api.patch<KnowledgeBaseEntry>("/crm/knowledge-base", { content }),
    onSuccess: () => {
      toast.success(
        "Base de conocimiento actualizada. Los cambios estarán activos en menos de 5 minutos.",
      );
      void queryClient.invalidateQueries({ queryKey: ["knowledge-base"] });
    },
    onError: (error) => {
      toast.error(error.message ?? "Error al guardar la base de conocimiento.");
    },
  });
}
